import React from 'react'
import './GetTheApp.css'
import bulletingicon from '../../images/bulleting-icon1.svg'
import downloadicon from '../../images/download-icon.svg'
import mockup1 from '../../images/get-app-mockup1.png'
import mockup2 from '../../images/get-app-mockup2.png'
import playstore from '../../images/dark-google-play.png'
import appstore from '../../images/dark-app-store.png'

const GetTheApp = () => {
    return (
        <div className='get-the-app'>

            <div className='container'>

                <div className='get-the-app-heading' ><h2>DOWNLOAD THE APP AND WIN UNLIMITED</h2></div>

                <div className='get-the-app-content'>

                    <div className='get-the-app-mockup' ><img src={mockup1} /></div>

                    <div className='get-the-app-content-text'>

                        <div className='get-the-app-points' >

                            <div className='point point1'><div className='point-icon'><img src={bulletingicon} /></div><h3>APP AVAILABLE FOR IOS & ANDROID</h3></div>
                            <div className='point point2'><div className='point-icon'><img src={bulletingicon} /></div><h3>50K+ HAPPY PLAYERS</h3></div>
                            <div className='point point3'><div className='point-icon'><img src={bulletingicon} /></div><h3>SELECT LANGUAGE OF YOUR CHOICE</h3></div>
                            <div className='point point4'><div className='point-icon'><img src={bulletingicon} /></div><h3>MINIMUM DEPOSITE ₹100</h3></div>

                        </div>

                        <div className='get-the-app-download'><div className='download' ><div className='download-icon'><img src={downloadicon} /></div><h3>Download Now</h3></div></div>

                        <div className='get-the-app-download-btn'>

                            <div className='playstore'><img src={playstore} /></div>
                            <div className='appstore'><img src={appstore} /></div>

                        </div>

                    </div>

                    <div className='get-the-app-mockup'><img src={mockup2} /></div>

                </div>

            </div>

        </div>
    )
}

export default GetTheApp
